import Vue from 'vue';
import { EventBus } from '@/event-bus';

export default Vue.extend({
  methods: {
    openHelp(template): void {
      EventBus.$emit('openHelp', template, this);
    },
  },
});
